module.exports = __webpack_public_path__ + "static/media/Panthers.981f2ece.svg";